"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AdminButtonDropdownToggle", {
    enumerable: true,
    get: function() {
        return AdminButtonDropdownToggle;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _ri = require("react-icons/ri");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const AdminButtonDropdownToggle = (param)=>{
    let { size, color } = param;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, " ", /*#__PURE__*/ _react.default.createElement(_ri.RiArrowDownSLine, {
        size: {
            sm: 16,
            md: 16,
            lg: 24
        }[size],
        style: {
            color,
            marginRight: {
                sm: "-3px",
                md: "-3px",
                lg: "-5px"
            }[size],
            marginLeft: {
                sm: "4px",
                md: "4px",
                lg: "8px"
            }[size]
        }
    }));
};

//# sourceMappingURL=AdminButtonDropdownToggle.js.map